var map = {
	"./2.png": 278,
	"./3.png": 280,
	"./4.png": 282,
	"./5.png": 284,
	"./v2/2.png": 169,
	"./v2/3.png": 170,
	"./v2/4.png": 171,
	"./v2/5.png": 172,
	"./v2/border-jackpot.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;